import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-6 bg-white border-y border-gold/10" data-id="element-128">
      <div className="max-w-3xl mx-auto text-center" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-cream mb-6" data-id="element-130">
          <ShieldCheck className="text-gold" size={32} data-id="element-131" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl font-serif text-ink mb-6" data-id="element-132">
          Tu satisfacción no es opcional — es el estándar.
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="font-sans text-lg text-ink-light leading-relaxed" data-id="element-133">
          Ingri lleva 8 años sin decepcionar a sus clientas. No porque tenga
          suerte. Porque se toma tu mirada en serio. <br data-id="element-134" />
          <br data-id="element-135" />
          <span className="font-bold text-ink" data-id="element-136">
            Si algo no quedó a tu gusto, hablamos. Punto.
          </span>
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-12 flex flex-col sm:flex-row justify-center gap-6" data-id="element-137">
          <div className="bg-cream px-8 py-5 rounded-sm border border-gold/10 shadow-sm" data-id="element-138">
            <p className="font-serif text-xl text-ink-dark italic" data-id="element-139">
              "No necesito filtro, mis pestañas se encargan"
            </p>
          </div>
          <div className="bg-cream px-8 py-5 rounded-sm border border-gold/10 shadow-sm" data-id="element-140">
            <p className="font-serif text-xl text-ink-dark italic" data-id="element-141">
              "Parpadeando con más confianza que nunca"
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}